/** Master membership tier — agent portal pricing + document waiver. */
export const MASTER_MEMBER_MEMBERSHIP_ID = 71;

/** 12% markup on supplier/API fare for Master member agents. */
export const MASTER_MEMBER_MARKUP_RATE = 0.12;

export const isMasterMemberAgent = (roleType, membership) =>
  Number(roleType) === 5 && Number(membership) === MASTER_MEMBER_MEMBERSHIP_ID;
